import { useCallback, useState } from 'react'

import { getIncident } from '@/apis/incident'
import { API_LIMIT } from '@/constants/api'
import useQueryPage from '@/hooks/useQueryPage'
import { GetIncidentResponse } from '@/types/apis/incident'

export const useIncident = () => {
  const currentPage = useQueryPage()
  const [page, setPage] = useState(currentPage)

  const [incidentResponse, setIncidentResponse] = useState<GetIncidentResponse>()
  const [loading, setLoading] = useState(false)

  const get = useCallback(async () => {
    try {
      setLoading(true)
      const res = await getIncident({ page, limit: API_LIMIT })
      setIncidentResponse(res)
    } finally {
      setLoading(false)
    }
  }, [page])

  return {
    loading,
    getIncident: get,
    incidentResponse,
    page,
    pageSize: API_LIMIT,
    setPage,
  }
}
